export const emptyCheck = {
    server: 'all',
    author_email: '',
    description: '',
    note: '',
    check_query: '',
    resolve_instructions: '',
};